import { proxyCustomElement, HTMLElement, h } from '@stencil/core/internal/client';
import { s as setDataTableRowIndicesOnSlotChange } from './cl-data-table.utils.js';

const clDataTableBodyCss = ":host(cl-data-table-body){display:table-row-group}";

const ClDataTableBody$1 = /*@__PURE__*/ proxyCustomElement(class ClDataTableBody extends HTMLElement {
  constructor() {
    super();
    this.__registerHost();
    this.__attachShadow();
  }
  render() {
    return h("slot", { onSlotchange: setDataTableRowIndicesOnSlotChange });
  }
  static get style() { return clDataTableBodyCss; }
}, [1, "cl-data-table-body"]);
function defineCustomElement$1() {
  if (typeof customElements === "undefined") {
    return;
  }
  const components = ["cl-data-table-body"];
  components.forEach(tagName => { switch (tagName) {
    case "cl-data-table-body":
      if (!customElements.get(tagName)) {
        customElements.define(tagName, ClDataTableBody$1);
      }
      break;
  } });
}

const ClDataTableBody = ClDataTableBody$1;
const defineCustomElement = defineCustomElement$1;

export { ClDataTableBody, defineCustomElement };

//# sourceMappingURL=cl-data-table-body.js.map